import { memo } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

type SectionTitleSchema = {
    title: string;
    dataAutomation?: string;
};

export const SectionTitle = memo(({ title, dataAutomation }: SectionTitleSchema) => (
    <Text
        fontVariant="h5_2"
        color={colorsPalettes.carbon[500]}
        data-automation={dataAutomation}
    >
        {title}
    </Text>
));
